import React from 'react'
import { CellProps, Renderer } from 'react-table'

export const OrderCell: Renderer<CellProps<Record<string, unknown>, string>> = ({ value }) => {
  return <>{value}</>
}
